<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Do You Pay Subcontractors Under CIS?</h1>
    <p>If your business hires other workers or companies to do construction work, you they may be acting as a contractor under the Construction Industry Scheme (CIS).</p>
    <p>This means you’re responsible for checking their CIS status, making the correct deductions from their payments (if needed), and submitting those details to HMRC.</p>
    <p>Do you pay subcontractors under CIS and need to submit CIS deductions to HMRC?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" :value=true v-model="formData.paysSubcontractors">Yes we pay subcontractors under CIS<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" :value=false v-model="formData.paysSubcontractors">No we do not pay subcontractors under CIS<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (props.formData.paysSubcontractors === undefined || props.formData.paysSubcontractors === null || props.formData.paysSubcontractors === '') {
    error.value.push('Please select an option.');
  }

  if (error.value.length > 0) return false;


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>